export const typedTabIndices = new Set();

export function hasTabBeenTyped(tabIndex) {
  return typedTabIndices.has(tabIndex);
}

export function markTabTyped(tabIndex) {
  typedTabIndices.add(tabIndex);
}

export function clearTypedTabsForTests() {
  typedTabIndices.clear();
}
